import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function MRFList() {
  const [mrfList, setMrfList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [siteMap, setSiteMap] = useState({});
  const [projectMap, setProjectMap] = useState({});
  const navigate = useNavigate();

  // ✅ ALWAYS dynamic (NO HARDCODE ISSUE)
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const companyId = user.company_id;

  // 🔹 LOAD SITES
  useEffect(() => {
    const loadSites = async () => {
      try {
        const snap = await getDocs(query(collection(db, "sites"), where("company_id", "==", companyId)));

        const map = {};
        snap.docs.forEach((doc) => {
          map[doc.id] = doc.data().site_name;
        });

        setSiteMap(map);
      } catch (err) {
        console.error(err);
      }
    };

    loadSites();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 🔹 LOAD PROJECTS
  useEffect(() => {
    const loadProjects = async () => {
      try {
        const snap = await getDocs(query(collection(db, "projects"), where("company_id", "==", companyId)));

        const map = {};
        snap.docs.forEach((doc) => {
          map[doc.id] = doc.data().project_name;
        });

        setProjectMap(map);
      } catch (err) {
        console.error(err);
      }
    };

    loadProjects();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 🔹 LOAD MRF
  useEffect(() => {
    const loadMRF = async () => {
      try {
        const snap = await getDocs(query(collection(db, "material_requests"), where("company_id", "==", companyId)));

        let data = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("USER COMPANY:", companyId);
        console.log("RAW MRF:", data);

        // ✅ STRICT MULTI-TENANT FILTER
        if (!companyId) {
          console.error("❌ No company_id in user");
          setMrfList([]);
          setLoading(false);
          return;
        }

        data = data.filter((mrf) => {
          return mrf.company_id === companyId;
        });

        console.log("FILTERED MRF:", data);

        // ✅ SORT
        data.sort(
          (a, b) =>
            (b.created_at?.seconds || 0) -
            (a.created_at?.seconds || 0)
        );

        setMrfList(data);
        setLoading(false);

      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    loadMRF();
  }, [companyId]);

  return (
    <div className="p-4 pb-20">
      <h1 className="text-xl font-semibold tracking-tight mb-4">
        Material Requests
      </h1>

      {loading && (
        <div className="text-center text-gray-400 text-sm mt-10">
          Loading MRF...
        </div>
      )}

      {!loading && mrfList.length === 0 && (
        <div className="text-center text-gray-400 text-sm mt-10">
          No MRF found
        </div>
      )}

      <div className="space-y-4">
        {mrfList.map((mrf) => {
          let cardColor = "bg-gray-400";
          let textColor = "text-white";

          // ✅ FULL STATUS COLORS
          if (mrf.status === "approved") {
            cardColor = "bg-green-500";
          } else if (mrf.status === "pending") {
            cardColor = "bg-yellow-400";
            textColor = "text-black";
          } else if (mrf.status === "rejected") {
            cardColor = "bg-red-500";
          } else if (mrf.status === "issued") {
            cardColor = "bg-blue-500";
          } else if (mrf.status === "partially_issued") {
            cardColor = "bg-orange-500";
          }

          // ✅ DATE + TIME FORMAT
          let formattedDate = "No date";
          let formattedTime = "";

          if (mrf.created_at?.toDate) {
            const d = mrf.created_at.toDate();

            formattedDate = d.toLocaleDateString("en-IN");
            formattedTime = d.toLocaleTimeString("en-IN", {
              hour: "2-digit",
              minute: "2-digit",
            });
          }

          return (
            <div
              key={mrf.id}
              onClick={() => navigate(`/store-mrf/${mrf.id}`)}
              className={`${cardColor} ${textColor} p-5 rounded-2xl shadow-md relative cursor-pointer hover:scale-[1.01] transition-all duration-200`}
            >
              {/* STATUS */}
              <div className="absolute top-4 right-4 text-xs font-bold tracking-wide opacity-90">
                {mrf.status?.toUpperCase()}
              </div>

              {/* PROJECT */}
              <div className="text-base font-bold">
                {projectMap[mrf.project_id] || "Project"}
              </div>

              {/* SITE */}
              <div className="text-sm mt-2 opacity-90">
                {siteMap[mrf.site_id] || mrf.site_name || "Site"}
              </div>

              {/* ITEMS */}
              <div className="text-xs mt-3 opacity-80">
                {mrf.items?.length || 0} items
              </div>

              {/* DATE + TIME */}
              <div className="text-xs mt-3 opacity-75">
                {formattedDate} • {formattedTime}
              </div>

              {/* VIEW BUTTON */}
              <div className="mt-4">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/store-mrf/${mrf.id}`);
                  }}
                  className="bg-black text-white px-4 py-1.5 rounded-lg text-xs font-medium hover:bg-gray-800"
                >
                  View
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}